import { render } from "./TeamEdit.vue?vue&type=template&id=2df170ab&scoped=true"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"

import "./TeamEdit.vue?vue&type=style&index=0&id=2df170ab&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df170ab"]])

export default __exports__